import type { ReactNode } from 'react';

export interface Detail {
  readonly label: string;
  readonly value: ReactNode;
  /** The figure the reader came for - the net paid, say. */
  readonly strong?: boolean;
  readonly testId?: string;
}

/**
 * A record's facts as label and value, two to a row on a wide screen and one
 * on a narrow one - how the finance detail screens show a payment and its
 * advice.
 */
export function DetailList({ items }: { readonly items: readonly Detail[] }): ReactNode {
  return (
    <dl
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
        gap: '14px 32px',
        margin: 0,
      }}
    >
      {items.map((d) => (
        <div key={d.label} data-testid={d.testId} style={{ minWidth: 0 }}>
          <dt style={{ fontSize: 12, letterSpacing: 0.4, textTransform: 'uppercase', color: 'var(--color-text-muted)', marginBottom: 4 }}>
            {d.label}
          </dt>
          <dd style={{ margin: 0, fontSize: d.strong ? 20 : 15, fontWeight: d.strong ? 700 : 600, color: 'var(--color-text-primary)', overflowWrap: 'anywhere' }}>
            {d.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
